import { useEffect, useState } from 'react';
import { canWriteEmpresaData } from '../../auth/session';
import { createItem, deleteItem, fetchList, updateItem } from './api';
import CrudModal from '../../components/layout/CrudModal';
import { toast } from 'react-hot-toast';

const EMPTY = {
  codigo: '',
  descricao: '',
  responsavel: '',
  ativo: true,
  codigo_contabil_integracao: '',
};

const ConstrutorCentrosCustoPage = () => {
  const canWrite = canWriteEmpresaData();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState('');
  const [showFormModal, setShowFormModal] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const data = await fetchList('/api/construtor/centros-custo', { q, page, pageSize: 10 });
      setItems(Array.isArray(data?.items) ? data.items : []);
      setTotal(Number(data?.total || 0));
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao carregar centros de custo');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...form,
      codigo_contabil_integracao: form.codigo_contabil_integracao || '',
    };
    try {
      if (editingId) {
        await updateItem('/api/construtor/centros-custo', editingId, payload);
        toast.success('Centro de custo atualizado');
      } else {
        await createItem('/api/construtor/centros-custo', payload);
        toast.success('Centro de custo salvo');
      }
      setEditingId('');
      setForm(EMPTY);
      setShowFormModal(false);
      await load();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao salvar centro de custo');
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm('Excluir centro de custo?')) return;
    try {
      await deleteItem('/api/construtor/centros-custo', id);
      toast.success('Centro de custo excluido');
      await load();
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao excluir centro de custo');
    }
  };

  const onEdit = (item) => {
    setEditingId(item.id);
    setForm({
      codigo: item.codigo || '',
      descricao: item.descricao || '',
      responsavel: item.responsavel || '',
      ativo: item.ativo !== false,
      codigo_contabil_integracao: item.codigo_contabil_integracao || '',
    });
    setShowFormModal(true);
  };

  const totalPages = Math.max(1, Math.ceil(total / 10));

  return (
    <div className="animate-fade-in space-y-6">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Centros de Custo</h1>
        {canWrite && (
          <button
            type="button"
            className="btn-primary"
            onClick={() => {
              setEditingId('');
              setForm(EMPTY);
              setShowFormModal(true);
            }}
          >
            Incluir Centro
          </button>
        )}
      </div>

      {canWrite && (
        <CrudModal
          open={showFormModal}
          title={editingId ? 'Editar Centro de Custo' : 'Novo Centro de Custo'}
          onClose={() => {
            setShowFormModal(false);
            setEditingId('');
            setForm(EMPTY);
          }}
          maxWidthClass="max-w-5xl"
        >
          <form onSubmit={onSubmit} className="space-y-5">
            <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
              <p className="text-sm font-semibold text-gray-800">Integracao de Centro de Custo</p>
              <p className="text-xs text-gray-500 mt-1">Mapeie os centros do construtor para seu sistema contabil.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="form-label">Codigo</label>
                <input className="form-input" placeholder="Ex.: CCT-001" value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value })} />
              </div>
              <div>
                <label className="form-label">Descricao</label>
                <input className="form-input" placeholder="Descricao do centro" value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} />
              </div>
              <div>
                <label className="form-label">Responsavel</label>
                <input className="form-input" placeholder="Nome do responsavel" value={form.responsavel} onChange={(e) => setForm({ ...form, responsavel: e.target.value })} />
              </div>
              <div>
                <label className="form-label">Codigo Contabil Integracao</label>
                <input
                  className="form-input"
                  maxLength={15}
                  placeholder="Maximo 15 caracteres"
                  value={form.codigo_contabil_integracao}
                  onChange={(e) => setForm({ ...form, codigo_contabil_integracao: e.target.value })}
                />
              </div>
              <div className="flex items-end pb-2">
                <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                  <input type="checkbox" checked={form.ativo} onChange={(e) => setForm({ ...form, ativo: e.target.checked })} />
                  Ativo
                </label>
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 border-t pt-4">
              <button
                className="btn-secondary"
                type="button"
                onClick={() => {
                  setShowFormModal(false);
                  setEditingId('');
                  setForm(EMPTY);
                }}
              >
                Cancelar
              </button>
              <button className="btn-primary" type="submit">{editingId ? 'Atualizar Centro' : 'Salvar Centro'}</button>
            </div>
          </form>
        </CrudModal>
      )}

      <div className="card">
        <div className="card-header flex items-center gap-3">
          <input className="form-input max-w-sm" placeholder="Buscar centro..." value={q} onChange={(e) => setQ(e.target.value)} />
          <button className="btn-secondary" onClick={() => { setPage(1); load(); }}>Buscar</button>
        </div>
        <div className="card-body p-0">
          <div className="table-container">
            <table className="table">
              <thead>
                <tr>
                  <th>Codigo</th>
                  <th>Descricao</th>
                  <th>Responsavel</th>
                  <th>Cod. Integracao</th>
                  <th>Status</th>
                  <th>Acoes</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id}>
                    <td>{it.codigo}</td>
                    <td>{it.descricao}</td>
                    <td>{it.responsavel || '-'}</td>
                    <td>{it.codigo_contabil_integracao || '-'}</td>
                    <td>{it.ativo ? 'Ativo' : 'Inativo'}</td>
                    <td>
                      {canWrite && <button className="btn-secondary mr-2" onClick={() => onEdit(it)}>Editar</button>}
                      {canWrite && <button className="btn-danger" onClick={() => onDelete(it.id)}>Excluir</button>}
                    </td>
                  </tr>
                ))}
                {!loading && items.length === 0 && <tr><td colSpan={6} className="text-center text-gray-500 py-6">Sem dados</td></tr>}
                {loading && <tr><td colSpan={6} className="text-center text-gray-500 py-6">Carregando...</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-body border-t flex items-center justify-between">
          <span className="text-sm text-gray-600">Pagina {page} de {totalPages} ({total} registros)</span>
          <div className="flex gap-2">
            <button className="btn-secondary" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Anterior</button>
            <button className="btn-secondary" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Proxima</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConstrutorCentrosCustoPage;
